import { httpRequest } from "@/lib";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type Props = {
  status: string;
  page: string | null;
  per_page?: number | null;
  employeeId: string;
  patientId: string;
  paymentMethod: string;
  startDate: string;
  endDate: string;
  accountId: string;
};

const requestFinancialPatientReportPDF = async ({ status, page, per_page, employeeId, patientId, paymentMethod, startDate, endDate, accountId }: Props) => {
  const response = await httpRequest.get(`/financy-entry-report-in-pdf?status=${status}&accountId=${accountId}&startDate=${startDate}&endDate=${endDate}&page=${page || 1}&per_page=${per_page || 10}&employeeId=${employeeId}&patientId=${patientId}&paymentMethod=${paymentMethod}`, {
    responseType: "blob",
  });
  return response.data;
};

export function useRequestFinancialPatientsPDFMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: requestFinancialPatientReportPDF,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["financial-patients-request-pdf"] });
    },
  });
}
